import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { overlay } from './Reducers/Overlay.reducer';
import { productsView } from './Reducers/ProductsView.reducer';
import { loadMore } from './Reducers/LoadMore.reducer';
import { quickOrder } from './Reducers/QuickOrder.reducer';
import { productPage } from './Reducers/ProductPage.reducer';
import { priceToggle } from './Reducers/PriceToggle.reducer';
import { priceHistory } from './Reducers/PriceHistory.reducer';

const staticReducers = {
  cart,
  quickSearch,
  navigation,
  facetedSearch,
  checkout,
  myPage,
  overlay,
  productsView,
  loadMore,
  quickOrder,
  productPage,
  priceToggle,
  priceHistory
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
};

export default app;
